import {images} from './images'
import {CategoryDetails, Category, MetaTagsProps} from "@/types";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {
    Camera,
    Video,
    Palette,
} from 'lucide-react';
import {category as service1, createMetaTags as tags1} from "./1";
import {category as service2, createMetaTags as tags2} from "./2";
import {category as service3, createMetaTags as tags3} from "./3";
import {category as service4, createMetaTags as tags4} from "./4";
import {category as service5, createMetaTags as tags5} from "./5";
import {OG_PATH, WEBSITE_URL} from "@/content";


const slug = 'level-2-electrical-services-asp-accredited-sydney'
const categoryId = 1
export const headCategory: Category = {
    id: 1,
    key: 'lvl2',
    name: 'Level 2 Electrical Services (ASP-Accredited)',
    long_name: 'Level 2 Electrical Services (ASP-Accredited) in Sydney',
    slug,
    categoryType: 'services',
}

export const metaTags: MetaTagsProps = {
    title: "Level 2 Electrical Services (ASP-Accredited) in Sydney",
    description: "Level 2 Electrical Services (ASP-Accredited) - ProElec Group offers expert Level 2 electrical services in Sydney, including overhead and underground service installations, meter box upgrades, and emergency repairs. Our licensed ASP electricians ensure safe and reliable solutions for your home or business.",
    keywords: "level 2 electrical services Sydney, ASP electrician Sydney, overhead service installation, underground service installation, meter box upgrade Sydney, emergency electrical repairs, electrical safety Sydney, licensed electricians Sydney",
    url: `${WEBSITE_URL}/${headCategory.categoryType}/${headCategory.slug}`,
    ogImage: `${OG_PATH}c${categoryId}.jpg`,
    type: "website",
}
export const subCategoryObject = Object.fromEntries(
    Object.entries({
        category1Service1: {...service1, ...tags1(metaTags)},
        category1Service2: {...service2, ...tags2(metaTags)},
        category1Service3: {...service3, ...tags3(metaTags)},
        category1Service4: {...service4, ...tags4(metaTags)},
        category1Service5: {...service5, ...tags5(metaTags)}
    }).map(([key, value]) => [key, {...value, headCategory}])
);

const subCategories = Object.values(subCategoryObject);

export const categoryDetails: CategoryDetails = {
    ...headCategory,
    metaTags,
    heroImage:{id:1, original: '/images/services/1/highlights/sydney-driveways.jpg', alt: 'Sydney Driveways'},
    order: 1,
    icon: <EmojiEventsIcon/>,
    description: ['Level 2 Electrical Services (ASP-Accredited) are specialized electrical services that involve work on the electrical supply network, including overhead and underground service installations, meter box upgrades, and emergency repairs. These services require a higher level of expertise and accreditation, as they involve direct interaction with the electricity supply to ensure safety and compliance with regulations.'],
    points: [
        {
            title: 'HeadCategory1DescriptionPoint1',
            icon: Camera,
        },
        {
            title: 'HeadCategory1DescriptionPoint2',
            icon: Video,
        },
        {
            title: 'HeadCategory1DescriptionPoint3',
            icon: Palette,
        },
    ],
    videos: [],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    subCategories,
}
